import {
  API_BASE_URL
} from 'shared/utils/Constants';

export const KIOSK_SETTINGS_URL = token => {
  return `${API_BASE_URL}/kiosk/${token}/settings`;
}

export const KIOSK_ME_URL = token => {
  return `${API_BASE_URL}/kiosk/${token}/me`;
}

export const KIOSK_LOGIN_URL = token => {
  return `${API_BASE_URL}/kiosk/${token}/login`;
}

export const KIOSK_READER_UPDATE_URL = token => {
  return `${API_BASE_URL}/kiosk/${token}/reader`;
}

export const KIOSK_LOGOUT_URL = () => {
  return `${API_BASE_URL}/user/logout`;
}

export const KIOSK_JOBS_URL = (token, since) => {
  if (since) {
    return `${API_BASE_URL}/kiosk/${token}/jobs?version=1&since=${since}`;
  } else {
    return `${API_BASE_URL}/kiosk/${token}/jobs?version=1`;
  }
}

export const KIOSK_MOMENTS_URL = (token, jobId, page, perPage, since) => {
  if (since) {
    return `${API_BASE_URL}/kiosk/${token}/moments?job_id=${jobId}&&page=${page}&per_page=${perPage}&since=${since}`;
  } else {
    return `${API_BASE_URL}/kiosk/${token}/moments?job_id=${jobId}&&page=${page}&per_page=${perPage}`;
  }
}

export const KIOSK_SELECTION_URL = (token, storyId) => {
  return `${API_BASE_URL}/kiosk/${token}/selection/${storyId}`;
}

export const KIOSK_UNSELECT_URL = (token, storyId, momentId) => {
  return `${API_BASE_URL}/kiosk/${token}/selection/${storyId}/${momentId}`;
}

export const KIOSK_GUESTS_URL = (token, storyId) => {
  return `${API_BASE_URL}/kiosk/${token}/guests?story_id=${storyId}`;
}

export const KIOSK_LOGO_URL = (token, locale) => {
  return `${API_BASE_URL}/kiosk/${token}/logo?locale=${locale}&t=${Date.now()}`;
}

export const KIOSK_BACKGROUND_URL = (token, locale) => {
  return `${API_BASE_URL}/kiosk/${token}/background?locale=${locale}&t=${Date.now()}`;
}

export const CUSTOMER_UPDATE_URL = customerId => {
  return `${API_BASE_URL}/portal/customers/${customerId}`;
}

export const ROOM_MOMENTS_URL = (token, storyId, page, perPage) => {
  return `${API_BASE_URL}/kiosk/${token}/room?story_id=${storyId}&page=${page}&per_page=${perPage}`;
}

export const FAMILIES_URL = token => {
  return `${API_BASE_URL}/kiosk/${token}/family`;
}

export const VISITS_URL = (token, familyId) => {
  return `${API_BASE_URL}/kiosk/${token}/family/${familyId}/visits`;
}

export const VISIT_URL = (token, familyId, id) => {
  return `${API_BASE_URL}/kiosk/${token}/family/${familyId}/visits/${id}`;
}

export const SEARCH_VISITS_URL = (token, room) => {
  return `${API_BASE_URL}/kiosk/${token}/visits?room=${room}`;
}

export const MERGED_STORIES_URL = (token, storyId) => {
  return `${API_BASE_URL}/kiosk/${token}/merged_stories?story_id=${storyId}`;
}

export const ADD_MERGED_STORY_URL = token => {
  return `${API_BASE_URL}/kiosk/${token}/merged_stories`;
}

export const SEARCH_CUSTOMERS_URL = (token, customerId, search) => {
  return `${API_BASE_URL}/kiosk/${token}/customers?customer_id=${customerId}&search=${search}`;
}

export const AUTHORIZE_PIN_URL = accountId => {
  return `${API_BASE_URL}/accounts/${accountId}/user/pin/authorize`;
}

export const GET_KIOSK_PRINT_SIZES_URL = kioskId => {
  return `${API_BASE_URL}/kiosks/${kioskId}/print_sizes`;
}

export const MOMENT_PRINT_SIZES_URL = (kioskId, momentId) => {
  return `${API_BASE_URL}/kiosks/${kioskId}/available_print_sizes/${momentId}`
}

export const SEARCH_MOMENTS_URL = () => {
  return `${API_BASE_URL}/v2/portal/moments`;
}

export const GET_KNOCKOUT_ELEMENTS = (momentId, printSizeString) => {
  return `${API_BASE_URL}/knockout/get_knockout_elements/${momentId}/${printSizeString}`;
}

export const FETCH_KNOCKOUT_IMAGE = (momentId) => {
  return `${API_BASE_URL}/moment/url/${momentId}?scale=knockout`;
}

export const BACKUP_MOMENT_URL = (momentId) => {
  return `${API_BASE_URL}/moment/${momentId}/backup`;
}

export const STRIPE_KIOSK_READERS_URL = (token) => {
  return `${API_BASE_URL}/stripe/${token}/stripe_kiosk_readers`;
}

export const STRIPE_KIOSK_READER_URL = (token, readerId) => {
  return `${API_BASE_URL}/stripe/${token}/stripe_kiosk_readers/${readerId}`;
}

export const VALIDATE_KNOCKOUT_ELEMENTS_URL = (id, printSizeString) => {
  return `${API_BASE_URL}/knockout/${id}/validate_elements_aspect?print_size=${printSizeString}`;
}

export const ACCESS_CODE_LOGIN_TYPE = 0;
export const EMAIL_LOGIN_TYPE = 1;
export const CLUB_MED_LOGIN_TYPE = 2;

export const HAGGLE_CHECKOUT_TYPE = 0;
export const MARKETPLACE_CHECKOUT_TYPE = 1;
export const KIOSK_PRICING_CHECKOUT_TYPE = 2;


export const STRIPE_PAYMENT_METHOD = 0;
export const OFFSITE_POS_PAYMENT_METHOD = 1;
export const STRIPE_READER_PAYMENT_METHOD = 3;
export const TILBY_PAYMENT_METHOD = 4;

export const GENERIC_OFFSITE_POS_TYPE = 0;
export const BILL_TO_ROOM_OFFSITE_POS_TYPE = 1;

export const GENERIC_BUTTON_TYPE = 0;
export const CLUB_MED_BUTTON_TYPE = 1;

export const CATALOG_SCREEN = 0;
export const GALLERY_SCREEN = 1;
export const CART_SCREEN = 2;

export const DOUBLE_PANE_RECEIPT_SCREEN_TYPE = 0;
export const SINGLE_PANE_RECEIPT_SCREEN_TYPE = 1;
